import { Alert, AlertProps, Stack, Text, useMantineTheme } from '@mantine/core'
import React, { FC } from 'react'

interface CustomAlertProps extends AlertProps {
  title: string
}

const CustomAlert: FC<CustomAlertProps> = ({ children, title, ...props }) => {
  const theme = useMantineTheme()

  return (
    <Alert
      {...props}
      style={{
        height: '-webkit-fill-available',
        maxHeight: 'fit-content',
        textAlign: 'left',
        fontFamily: theme.fontFamily,
        padding: '10px',
        borderRadius: '8px',
        ...props.style,
      }}
      icon={null}
      title={
        <Stack style={{ flexDirection: 'row', gap: '8px', alignItems: 'center' }}>
          {props.icon && <div style={{ display: 'flex' }}>{props.icon}</div>}
          <Text
            style={{
              color: props.color,
              fontFamily: 'monument-grotesk-bold',
              fontSize: '16px',
              paddingTop: '2px',
            }}
          >
            {title}
          </Text>
        </Stack>
      }
    >
      <div style={{ color: theme.colors.title[0], fontSize: '14px' }}>{children}</div>
    </Alert>
  )
}
export default CustomAlert
